import styled from 'styled-components';

type BubbleProps = {
  $below: boolean;
  $alignRight: boolean;
};

const Bubble = styled.span<BubbleProps>`
  position: fixed;
  transform: translate(
    ${({ $alignRight }) => ($alignRight ? '-100%' : '0')},
    ${({ $below }) => ($below ? '0' : '-100%')}
  );
  max-width: 320px;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.outline};
  background-color: ${(props) => props.theme.colors.widget_background};
  box-shadow: ${(props) => props.theme.shadows.dropdown};
  color: ${(props) => props.theme.colors.text};
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 9999;
  pointer-events: none;
`;

export default { Bubble };
